<script setup lang="ts"></script>
<template>
  <div class="app">
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>
<style>
.header-text {
  margin-top: 10px;
}

@media only screen and (min-width: 990px) {
  .app-header .navbar-brand {
    width: 330px;
  }
}
</style>
